import type {Dayjs} from 'dayjs'
import type {DateRange} from '../../../../components/dateRangeSelector/DateRangeSelector.tsx'

export const isInWeek = (week: DateRange, date: Dayjs | null): boolean => {
  if (!date) return false
  if (date.isSame(week.start)) return true
  if (date.isSame(week.end)) return true
  return date.isAfter(week.start) && date.isBefore(week.end)
}
